import React, { useState, useMemo } from 'react';
import { helpers } from '../services/helpers';
import { InformationCircleIcon } from "@heroicons/react/20/solid";
import FooterNavigation from './FooterNavigation';
import StarRating from './StarRating';

function DiarySurgeryCard({
    surgeries,
    currentIndex,
    leftClick,
    rightClick,
    closeCard,
    cardVisible
}) {
    // TODO: SWIPE LOGIC IS DUPLICATED
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const minSwipeDistance = 50;

    const handleTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (!touchStart || !touchEnd) return;

        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;

        if (isLeftSwipe) {
            rightClick();
        } else if (isRightSwipe) {
            leftClick();
        }
    };
    const entry = surgeries?.[currentIndex]

    if (!cardVisible) {
        return (
            <div></div>
        )
    }
    return (
        <div style={{ padding: "0px 0.5rem" }}>
            {entry ? (
                <div
                    className="update-card"
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                    style={{ padding: "0", paddingBottom: "0.5rem" }}
                >
                    <div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div className="update-header" style={{ marginBottom: "0", paddingLeft: "12px" }}>
                                <span className="post-op-timestamp">
                                    {entry.isUpdate ? (
                                        helpers.postopTimestampAt(entry.surgeryDate, entry.update.createdAt)
                                    ) : (
                                        helpers.formatTime(entry.sharedDate)
                                    )}
                                </span>
                            </div>
                            <button className="cancel-button" onClick={closeCard}>
                                ×
                            </button>
                        </div>
                    </div>

                    <div style={{ paddingLeft: "12px", paddingRight: "12px" }}>

                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div className="review-header" style={{ height: '24px', fontSize: '14px' }}>
                                <div style={{ fontWeight: 'bold', color: '#606366' }}>{entry.state.code}&nbsp;•&nbsp;</div>
                                <div style={{ color: '#000000' }}>
                                    {entry.surgeon.name.replace(/,\s*m\.?d\.?$/i, '')}
                                </div>
                            </div>
                            <div></div>
                        </div>
                        <div>{Boolean(entry?.update?.rating) && (
                            <StarRating className="star-rating" rating={entry.update.rating} />
                        )}
                            <div className="review-details">
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    {entry.procedures.map((procedure, index) => {
                                        return (
                                            <div key={index} style={{ fontWeight: '600', fontSize: '14px' }}>
                                                <span className="tooltip-container" style={{ display: 'flex', alignItems: 'center' }}>
                                                    <InformationCircleIcon
                                                        style={{
                                                            width: '1rem',
                                                            height: '1rem',
                                                            cursor: 'pointer',
                                                            color: '#3498DA'
                                                        }}
                                                        aria-hidden="true"
                                                    />
                                                    {helpers.procedureDisplay(procedure)}

                                                    <span className="tooltip-text">{procedure.description}</span>
                                                </span>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            {entry?.update?.description && (
                                <p className="update-text">{entry.update.description}</p>
                            )}
                            <FooterNavigation
                                assetType="surgery update"
                                leftClick={leftClick}
                                rightClick={rightClick}
                                currentIndex={currentIndex}
                                length={surgeries.length}
                            />
                        </div>
                    </div>
                </div>
            ) : (
                <div></div>
            )}
        </div>
    )
}

export default DiarySurgeryCard;